import React from 'react'
import _ from 'lodash/fp'
import classNames from 'classnames'

import { Link } from 'react-router-dom'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'

import GenericMap, { GenerateUserPositionMarker, GlfrInfoWindow, InfoWindowStyles } from '../../components/Map'
import { ClubMarker } from '../Clubs/ClubsMap'

// Map things
import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer'

const getPrice = product => ({
  price: _.flow(_.get('variants.0.priceV2.amount'), Number)(product),
  compareAtPrice: _.flow(_.get('variants.0.compareAtPriceV2.amount'), Number)(product)
})

class OfferMarkerBase extends React.Component {
  state = {
    visible: true
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    // If the map changes to or from mini, set the visible state
    if (_.get('mini', nextProps) && !_.get('mini', this.props)) {
      this.setState({
        visible: false
      })
    } else if (!_.get('mini', nextProps) && _.get('mini', this.props)) {
      this.setState({
        visible: true
      })
    }
  }

  render () {
    const { offer, small, classes } = this.props
    const { visible } = this.state
    if (!offer.club) {
      return null
    }
    const name = _.get('title', offer)
    const clubName = _.get('club.name', offer)
    const price = getPrice(offer)
    return (
      <ClubMarker
        club={_.get('club', offer)}
        onClick={() => this.setState(_.update('visible', (v) => !v))}
      >
        <GlfrInfoWindow
          visible={visible}
          onCloseClick={() => this.setState({ visible: false })}
          title={clubName}
          subtitle={name}
          link={`/offers/offer/${_.get('handle', offer)}`}
          small={small}
          left={(
            <div style={{ marginRight: 10 }}>
              <Typography variant={small ? 'body2' : 'subtitle1'} className={classes.price}>{_.get('price', price)}kr.</Typography>
              {!small && !!price.compareAtPrice && <Typography variant='subtitle1' className={classes.compareAtPrice}>{_.get('compareAtPrice', price)}kr.</Typography>}
            </div>
          )}
          right={(
            !small && (
              <div style={{ textAlign: 'right' }}>
                <Typography component={Link} to={`/offers/offer/${_.get('handle', offer)}`} className={classNames(classes.link, classes.readLink)}>Read more</Typography>
                <Typography component='a' target='_blank' rel='noopener noreferrer' href={_.get('url.value', offer)} className={classNames(classes.link, classes.bookLink)}>Book now</Typography>
              </div>
            )
          )}
        />
      </ClubMarker>
    )
  }
}

const OfferMarker = withStyles(InfoWindowStyles)(OfferMarkerBase)

/*
  Feeds the map with ClubMarker Markers, also sets the cente of the map
*/
export default class OffersMap extends React.Component {
  initOffers = (props) => {
    this.offerMarkers = _.map((offer) => (
      <OfferMarker key={_.get('id', offer)} offer={offer} small={props.small} mini={props.mini} />
    ), props.offers)
  }

  offerMarkers = []

  UNSAFE_componentWillMount () {
    this.initOffers(this.props)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.props.offers !== nextProps.offers || _.isEmpty(this.offerMarkers)) {
      this.initOffers(nextProps)
    }
  }

  render () {
    const { position, offers, ...props } = this.props
    return (
      <GenericMap
        placeholder='Find offers near...'
        defaultZoom={8}
        defaultCenter={{ lat: _.get('latitude', position) || 56.21, lng: _.get('longitude', position) || 11.24 }}
        containerElement={<div style={{ height: '50vh' }} />}
        {...props}
      >
        {position && GenerateUserPositionMarker(position)}
        <MarkerClusterer
          averageCenter
          enableRetinaIcons
          gridSize={20}
        >
          {this.offerMarkers}
        </MarkerClusterer>
      </GenericMap>
    )
  }
}
